import * as React from 'react';
import * as _ from 'lodash-es';

import Drawer from '@mui/material/Drawer';
import { hasPermission } from '../../helpers/Permission';

import { connectWithRouter } from 'helpers/connectWithRouter';
import { bindActionCreators, Dispatch } from 'redux';
import { ReduxState } from '../../reducers/types';
import { logout } from '../../actions/User/Login';
import { reset } from '../../analytics/analytics';

import SidebarMenu from '../SidebarMenu/SidebarMenu';
import { PermissionTypes } from '../../constants';
import { NavigateFunction } from 'react-router-dom';

type Props = {
  logout: Function;
  navigate: NavigateFunction;
};

const styles = require('./style.pcss');

class Sidebar extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  handleNavigation = (path: string) => {
    this.props.navigate(path);
  };

  shouldComponentUpdate(nextProps: any) {
    if (_.get(nextProps.userLogin, 'isLoggedIn', false) === false) {
      reset();
      this.handleNavigation(`/login`);
      return false;
    }

    return true;
  }

  logout = () => {
    this.props.logout();
  };

  renderAdminSetting() {
    if (hasPermission('blackBox', PermissionTypes.read)) {
      return (
        <div
          className={
            window.location.pathname.includes('/manage-bb')
              ? styles.active
              : styles.inactive
          }
          onClick={() => {
            this.handleNavigation(`/manage-bb`);
          }}
        >
          Admin Settings
        </div>
      );
    }

    return null;
  }

  render() {
    return (
      <Drawer
        className={styles.drawer}
        variant="permanent"
        anchor="left"
      >
        <div className={styles.logo}>BlackBox</div>
        <SidebarMenu />
        <div className={styles.bottomNav}>
          <div
            className={
              window.location.pathname.includes('/account')
                ? styles.active
                : styles.inactive
            }
            onClick={() => {
              this.handleNavigation(`/account`);
            }}
          >
            My Account
          </div>
          {this.renderAdminSetting()}
          <div onClick={this.logout}>Log Out</div>
        </div>
      </Drawer>
    );
  }
}

// Wire up redux state to component
function mapStateToProps(state: ReduxState) {
  return {
    userLogin: state.userLogin,
  };
}

// Wire up redux dispatch functions
function mapDispatchToProps(dispatch: Dispatch) {
  return bindActionCreators(
    {
      logout,
    },
    dispatch,
  );
}

// Connect it to Redux
export default connectWithRouter(
  mapStateToProps,
  mapDispatchToProps,
)(Sidebar);
